import { ReactNode } from 'react'
import { components, ValueContainerProps } from 'react-select'

import { SelectOption, SelectOptionGroup } from '../types'

export const valueContainerClassName = () => '!p-0 gap-2 !flex !flex-nowrap items-center flex-row min-w-0 overflow-hidden whitespace-nowrap cursor-pointer'

export function CustomValueContainer<T>(props: ValueContainerProps<SelectOption<T>, false, SelectOptionGroup<T>> & { icon?: ReactNode }) {
    const { icon, children, ...rest } = props
    return (
        <components.ValueContainer {...rest}>
            {icon && <span className="flex shrink-0 items-center">{icon}</span>}
            {children}
        </components.ValueContainer>
    )
}
